export const SALES_CONTACTS_TABLE_REQUEST = "SALES_CONTACTS_TABLE_REQUEST";
export const SALES_CONTACTS_TABLE_SUCCESS = "SALES_CONTACTS_TABLE_SUCCESS";
export const SALES_CONTACTS_TABLE_FAIL = "SALES_CONTACTS_TABLE_FAIL";

export const SALES_FILTERS_REQUEST = "SALES_FILTERS_REQUEST";
export const SALES_FILTERS_SUCCESS = "SALES_FILTERS_SUCCESS";
export const SALES_FILTERS_FAIL = "SALES_FILTERS_FAIL";
